// Models
import { BaseModel } from '../../../woopa-ui/api';
import { Placement } from './';

/**
 * Represents a review in the app.
 */
export interface Review extends BaseModel {
  result: number;
  createdAt: string;
  placement: Placement;
  supervisor: any;
  // Optional
  observations?: any;
  answerIds?: any[];
}

/**
 * List of review results.
 */
export const REVIEW_RESULTS = ['Correcto', 'Advertencia', 'Falla'];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/review.interface.ts